import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ShippingComponent from "./Shippings";
// import InvoicesComponent from "../Billings/Invoices";
import RemittanceComponent from "../Billings/Remittance";
import PassbookComponent from "./PassBook";
import EarlyCODModal from "./EarlyCodPopup";
import WalletHistory from "./WalletHistory";
import Cookies from "js-cookie";
// import DowngradeComponent from "../Billings/Downgrade";
import { Truck, Banknote, BookOpen, Wallet } from "lucide-react";
import { Lock } from "lucide-react";

const icons = {
  Shipping: <Truck className="w-4 h-4" />,
  "COD Remittance": <Banknote className="w-4 h-4" />,
  PassBook: <BookOpen className="w-4 h-4" />,
  "Wallet History": <Wallet className="w-4 h-4" />,
};

const Billing = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedItem, setSelectedItem] = useState("Shipping");
  const [totalShipments, setTotalShipments] = useState(0);
  const [totalFreightCharges, setTotalFreightCharges] = useState(0);
  const [searchQueries, setSearchQueries] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const [filtersApplied, setFiltersApplied] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [clearFiltersTrigger, setClearFiltersTrigger] = useState(false);
  const [balance, setBalance] = useState(0);
  const [holdAmount, setHoldAmount] = useState(0);
  const { id } = useParams();

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const toggleFilters = () => {
    if (filtersApplied) {
      // Trigger clear manually
      setClearFiltersTrigger(true); // Add this
      setFiltersApplied(false);
      setShowFilters(false);
    } else {
      setShowFilters((prev) => !prev);
    }
  };

  const clearFilters = () => { };

  const fetchWalletSummary = async () => {
    try {
      const token = Cookies.get("session");
      const params = {
        id
      }
      const response = await axios.get(`${REACT_APP_BACKEND_URL}/recharge/getWalletBalanceAndHoldAmount`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        setBalance(response.data.balance);
        setHoldAmount(response.data.holdAmount);
      } else {
        console.error("Failed to fetch wallet summary:", response.data.message);
      }
    } catch (err) {
      console.error("Error fetching wallet summary:", err);
    }
  };

  useEffect(() => {
    fetchWalletSummary();
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = Cookies.get("session");
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/orders`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );

        const orders = response.data;
        setTotalShipments(orders.length);

        const totalCharges = orders.reduce(
          (acc, order) => acc + (order.totalFreightCharges || 0),
          0
        );
        setTotalFreightCharges(totalCharges.toFixed(2));

        const responses = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/getUser`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );
        if (responses.data.isAdmin === true) {
          setIsAdmin(true);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, []);

  const handleSearch = (selectedItem, event) => {
    setSearchQueries({
      ...searchQueries,
      [selectedItem]: event.target.value,
    });
  };

  const handleBoxClick = (label) => {
    setSelectedItem(label);
  };
  // const adminCODcallback = () => {
  //   navigate("/dashboard/AdminCodRemittances");
  // };
  const getTotalShipmentsText = (label) => {
    switch (label) {
      case "Shipping":
        return "Total Shipments";
      // case "Invoices":
      //   return "Total Invoices raised";
      case "Remittance":
        return "Total COD Remitted";
      case "PassBook":
        return "Total Recharge Amount";

      // case "Downgrade":
      //   return "Total Downgrades Requests";
      default:
        return "Total Shipments";
    }
  };

  const tabs = ["Shipping", "COD Remittance", "PassBook", "Wallet History"];

  const renderComponent = () => {
    switch (selectedItem) {
      case "Shipping":
        return (
          <ShippingComponent
            showFilters={showFilters}
            setFiltersApplied={setFiltersApplied}
            clearFiltersTrigger={clearFiltersTrigger}
            setClearFiltersTrigger={setClearFiltersTrigger}
            setShowFilters={setShowFilters}
          />
        );
      // case "Invoices":
      //   return <InvoicesComponent />;
      case "COD Remittance":
        return <RemittanceComponent />;
      // return ""
      case "PassBook":
        return (
          <PassbookComponent
            showFilters={showFilters}
            setFiltersApplied={setFiltersApplied}
            clearFiltersTrigger={clearFiltersTrigger}
            setClearFiltersTrigger={setClearFiltersTrigger}
            setShowFilters={setShowFilters}
          />
        );
      case "Wallet History":
        return <WalletHistory />;
      // case "Downgrade":
      //   return <DowngradeComponent />;
      default:
        return null;
    }
  };

  return (
    <div className="sm:p-2 px-1 py-2 w-full">
      <div className="flex flex-row items-center sm:items-start justify-between mb-2 w-full">
        {!id && (
          <div className="mb-1">
            <h1 className="text-[12px] md:text-[18px] text-gray-700 font-[600]">Billings</h1>
          </div>
        )}



        {/* Search Box */}
        <div className="flex items-center">

          <div className="flex flex-row sm:flex-col w-full gap-2">
            <div className="w-full sm:w-full">
              <button
                onClick={() => setIsModalOpen(true)}
                className="w-full bg-[#632C9D]  text-white font-[600] px-3 py-2 rounded-lg text-[8px] sm:text-[10px]"
              >
                Early COD
              </button>
            </div>

            {/* {selectedItem?.toLowerCase() !== "cod remittance" && (
              <div className="w-1/2 sm:w-full">
                <button
                  onClick={toggleFilters}
                  className={`w-full flex items-center text-[12px] justify-center gap-2 px-2 py-1 rounded-lg border-[1px] transition-all duration-300 font-medium ${filtersApplied
                      ? "bg-white text-[#632C9D] border-red-500"
                      : showFilters
                        ? "bg-[#632C9D] text-white border-[#632C9D]"
                        : "bg-white text-[#632C9D] border-[#632C9D]"
                    }`}
                >
                  Filters
                  {filtersApplied && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="14"
                      height="14"
                      fill="none"
                      stroke="red"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  )}
                </button>
              </div>
            )} */}

            <EarlyCODModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
            />
          </div>
        </div>
      </div>
      {/* Balance + Hold green boxes */}
      <div className="flex gap-2 w-full md:w-3/12 mb-2">
        {/* Balance Box */}
        <div className="flex flex-row w-full bg-white text-gray-700 rounded-lg gap-2 px-2 h-14 items-center justify-start text-[12px] border-2 border-[#632C9D]">
          <div className="w-6 h-6 rounded-full flex justify-center items-center bg-[#632C9D] text-white">
            <Wallet className="w-3 h-3" />
          </div>

          <div className="flex flex-col font-[600]">
            <p>Wallet Balnce</p>
            <p className="font-[600]">{Number(balance).toFixed(2)}</p>
          </div>
        </div>

        {/* Hold Amount Box */}
        <div className="flex flex-row w-full bg-white text-gray-700 rounded-lg gap-2 px-2 h-14 items-center justify-start text-[12px] border-2 border-[#632C9D]">
          <div className="w-6 h-6 rounded-full flex justify-center items-center bg-[#632C9D] text-white">
            <Lock className="w-3 h-3" />
          </div>

          <div className="flex flex-col font-[600]">
            <p>Hold Amount</p>
            <p className="font-[600]">{holdAmount}</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row sm:mb-[-15px]">
        {/* Right Panel */}
        <div className="w-full">
          <div className="flex flex-col md:flex-row gap-4 md:gap-4">


            {/* Four Action Boxes */}
            <div className="hidden md:flex flex-wrap gap-2">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`px-3 py-2 text-[12px] md:text-[12px] rounded-lg font-[600] transition-all duration-200 ${selectedItem === tab
                    ? "bg-[#632C9D] text-white"
                    : "bg-white text-gray-700 hover:bg-purple-200"
                    }`}
                  onClick={() => setSelectedItem(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="relative md:hidden mb-[-15px]">
        <button
          className="w-full px-3 py-2 bg-[#632C9D] text-white rounded-lg text-[10px] flex justify-between items-center font-[600]"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          {selectedItem} <span className="ml-2">▼</span>
        </button>
        {showDropdown && (
          <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-lg shadow-lg z-10 font-[600]">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`w-full text-gray-700 text-left px-3 py-2 text-[10px] hover:bg-gray-200 ${selectedItem === tab ? "bg-purple-100" : "hover:bg-purple-50"}`}
                onClick={() => {
                  setSelectedItem(tab);
                  setShowDropdown(false);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        )}
      </div>
      {/* Render Selected Component */}
      <div className="mt-6">{renderComponent()}</div>
    </div>
  );
};

export default Billing;
